import * as React from 'react'
import { SVGProps } from 'react'

const SvgArrowRightBigIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 33 8' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      d='M32.354 4.354a.5.5 0 0 0 0-.708L29.172.464a.5.5 0 1 0-.707.708L31.293 4l-2.828 2.828a.5.5 0 1 0 .707.708l3.182-3.182ZM0 4.5h32v-1H0v1Z'
      fill='#3071EE'
    />
  </svg>
)

export default SvgArrowRightBigIcon
